import "@fontsource/figtree";
import "@fontsource/figtree/500.css";
import "@fontsource/figtree/600.css";
import "@fontsource/figtree/700.css";
import "@fontsource/figtree/400.css";
import styled from "styled-components";
import { theme } from "../../../theme";

const Subtitle = styled.div<{
  textalign?: string;
  color?: string;
  fontWeight?: number;
}>`
  font-family: "Figtree", sans-serif;
  font-size: 24px;
  color: ${(props) => props.color ?? theme.colors.text};
  text-align: ${(props) => props.textalign ?? "left"};
  font-weight: ${(props) => props.fontWeight ?? 500};
`;

export default Subtitle;
